import IvaMixin from "@/modules/afip/mixins/IvaMixin";
import RoundMixin from "@/modules/afip/mixins/RoundMixin";

export default {
    mixins: [IvaMixin, RoundMixin],
    computed: {
        receiptTotal(){
            return (CbteTipo, detalleProductoServicio) => {
                let receipt = {}
                this.addIvaToDetalleProductoServicio(CbteTipo, detalleProductoServicio)
                receipt.CbteTipo = CbteTipo
                receipt.ImpNeto = this.calculateImpNeto(detalleProductoServicio)
                receipt.Iva = this.calculateIVA(detalleProductoServicio)
                receipt.ImpTrib = 0
                receipt.ImpTotal = this.calculateImpTotal(detalleProductoServicio)
                return receipt
            }
        },
        calculateImpNeto() {
            return detalleProductoServicio => {
                if (!Array.isArray(detalleProductoServicio)) {
                    throw new Error("detalleProductoServicio must be an array")
                }

                return detalleProductoServicio.reduce((a, v) => a + v.subtotal, 0)
            }


        },
        calculateIVA () {

            return detalleProductoServicio => {
                if (!Array.isArray(detalleProductoServicio)) {
                    throw new Error("detalleProductoServicio must be an array")
                }

                let IVA = []

                detalleProductoServicio.forEach(item => {
                    let itemIVA = IVA.find(iv => iv.Id === item.alicuotaIva)
                    if (itemIVA) {
                        let baseImp = item.subtotal
                        let ImporteIva = item.subtotalConIva - item.subtotal
                        itemIVA.BaseImp += baseImp
                        itemIVA.Importe += ImporteIva
                    } else {
                        let baseImp = item.subtotal
                        let ImporteIva = item.subtotalConIva - item.subtotal
                        itemIVA = {Id: item.alicuotaIva, BaseImp: baseImp, Importe: ImporteIva}
                        IVA.push(itemIVA)
                    }
                })

                return IVA
            }
        },
        calculateImpTotal() {

            return detalleProductoServicio => {
                if (!Array.isArray(detalleProductoServicio)) {
                    throw new Error("detalleProductoServicio must be an array")
                }

                return detalleProductoServicio.reduce((a, v) => a + v.subtotalConIva, 0)
            }

        }
    },
    methods:{
        addIvaToDetalleProductoServicio (CbteTipo, detalleProductoServicio = []) {

            if (!Array.isArray(detalleProductoServicio)) {
                throw new Error("detalleProductoServicio must be an Array")
            }

            detalleProductoServicio.forEach(item => {

                item.alicuotaIvaPorcentaje = this.getPorcentajeAlicuota(item.alicuotaIva)

                //1 => A, 6 => B
                if (CbteTipo === 1 || CbteTipo === 6) {

                    let IvoForPrecioUnitario = this.round(item.precioUnitario * item.alicuotaIvaPorcentaje / 100)
                    item.precioUnitarioConIva = item.precioUnitario + IvoForPrecioUnitario

                    let IvoForSubtotal = this.round(item.subtotal * item.alicuotaIvaPorcentaje / 100)
                    item.subtotalConIva = item.subtotal + IvoForSubtotal
                }

            })

            return detalleProductoServicio
        }
    }
}
